module.exports = __webpack_public_path__ + "static/img/chrome_img_2.c18b714c.png";